import React, { Component, useContext } from "react"
import fr from "../locales/fr.json"
import en from "../locales/en.json"

const translations = { fr, en }

const defaultState = {
  lang: "fr",
  toggleLang: () => {},
  t: () => "",
}

const LanguageContext = React.createContext(defaultState)

class LanguageProvider extends Component {
  state = {
    lang: "fr",
  }

  componentDidMount() {
    const saved =
      typeof window !== "undefined" && window.localStorage.getItem("lang")
    if (saved === "en" || saved === "fr") {
      this.setState({ lang: saved })
    }
  }

  toggleLang = () => {
    const lang = this.state.lang === "fr" ? "en" : "fr"
    this.setState({ lang })
    if (typeof window !== "undefined") {
      window.localStorage.setItem("lang", lang)
    }
  }

  t = key => {
    const keys = key.split(".")
    let value = translations[this.state.lang]
    for (const k of keys) {
      if (value === undefined) return key
      value = value[k]
    }
    return value !== undefined ? value : key
  }

  render() {
    const { children } = this.props
    const { lang } = this.state
    return (
      <LanguageContext.Provider
        value={{
          lang,
          toggleLang: this.toggleLang,
          t: this.t,
        }}
      >
        {children}
      </LanguageContext.Provider>
    )
  }
}

const useTranslation = () => useContext(LanguageContext)

export default LanguageContext
export { LanguageProvider, useTranslation }
